export default store => store.personalizedPromotions;
